import { create } from 'zustand';

// ─── Contexto de proyecto ─────────────────────────────────────
// SOLO estado de UI: recuerda el proyecto activo al navegar desde el Tablero
// hacia un módulo, para que el módulo pueda pre-filtrar por ese proyecto.
interface ProyectoState {
  proyectoContextoId: string | null;
  setProyectoContexto: (id: string | null) => void;
}

export const useProyectoStore = create<ProyectoState>((set) => ({
  proyectoContextoId: null,
  setProyectoContexto: (id) => set({ proyectoContextoId: id }),
}));
